import { render, staticRenderFns } from "./msgPop.vue?vue&type=template&id=9c50400c&scoped=true"
import script from "./msgPop.vue?vue&type=script&lang=js"
export * from "./msgPop.vue?vue&type=script&lang=js"
import style0 from "./msgPop.vue?vue&type=style&index=0&id=9c50400c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c50400c",
  null
  
)

export default component.exports